// Debug overlay — performance stats rendered as a DOM element
// Values are smoothed (updated once per second, like Unreal's stat fps)

export class DebugOverlay {
  private el: HTMLDivElement;
  private fps = 0;
  private frames = 0;
  private lastUpdateTime = performance.now();

  // Smoothed values (updated once per second)
  private dispFps = 0;
  private dispCpu = 0;
  private dispGpu = 0;
  private dispSim = 0;

  // Accumulators for averaging
  private cpuSum = 0;
  private gpuSum = 0;
  private gpuSamples = 0;
  private simSum = 0;

  constructor() {
    this.el = document.createElement("div");
    this.el.style.cssText =
      "position:fixed;bottom:0;left:0;color:#0f0;font:12px monospace;" +
      "padding:8px;pointer-events:none;z-index:9999;background:rgba(0,0,0,0.6)";
    document.body.appendChild(this.el);
  }

  update(simMs: number, renderMs: number, entityCount: number, tick: number, playerY?: number, gpuMs?: number, playerX?: number, playerZ?: number, triCount?: number): void {
    this.frames++;
    this.cpuSum += renderMs;
    this.simSum += simMs;
    if (gpuMs !== undefined && gpuMs < 100) { // ignore spikes (GC, compositor stalls)
      this.gpuSum += gpuMs;
      this.gpuSamples++;
    }

    const now = performance.now();
    if (now - this.lastUpdateTime >= 1000) {
      this.dispFps = this.frames;
      this.dispCpu = this.cpuSum / this.frames;
      this.dispSim = this.simSum / this.frames;
      this.dispGpu = this.gpuSamples > 0 ? this.gpuSum / this.gpuSamples : 0;

      this.frames = 0;
      this.cpuSum = 0;
      this.simSum = 0;
      this.gpuSum = 0;
      this.gpuSamples = 0;
      this.lastUpdateTime = now;

      const posStr = playerX !== undefined
        ? ` | ${playerX.toFixed(1)}, ${(playerY ?? 0).toFixed(1)}, ${(playerZ ?? 0).toFixed(1)}`
        : playerY !== undefined ? ` | Y: ${playerY.toFixed(1)}` : "";
      const triStr = triCount !== undefined ? ` | ${(triCount / 1000).toFixed(0)}K tris` : "";
      this.el.textContent =
        `${this.dispFps} FPS | CPU: ${this.dispCpu.toFixed(1)}ms | GPU: ${this.dispGpu.toFixed(1)}ms` +
        ` | Sim: ${this.dispSim.toFixed(1)}ms | ${entityCount} ent${triStr}${posStr}`;
    }
  }

  destroy(): void {
    this.el.remove();
  }
}
